import { CSVLink } from 'react-csv'
import { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'

import {
  STATUS_PENGIRIMAN_LABEL,
  PERILAKU_KERJA_RATING_LABEL,
  PRAKTIK_KINERJA_RATING_LABEL,
} from 'app/KinerjaShared/constants/penetapanPredikatKinerja'
import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'
import { PREDIKAT_LABELS } from 'app/KinerjaShared/components/PenetapanPredikatTable/constants'
import { generateCsvFileName } from 'app/KinerjaShared/components/PenetapanPredikatTable/utils'

import type { CSVLinkProps } from 'react-csv'
import type {
  ColumnConfig,
  ColumnKey,
} from 'app/KinerjaShared/components/PenetapanPredikatTable/type'

type DownloadActionProps = {
  columns: Array<ColumnConfig>
  fileName?: string
}

type DownloadItem = Partial<Record<ColumnKey, string>>

export function DownloadAction({ columns, fileName }: DownloadActionProps) {
  const { filteredItems } = usePenetapanPredikatTableStore((store) => ({
    filteredItems: store.filteredItems,
  }))

  const headers: CSVLinkProps['headers'] = useMemo(
    () =>
      columns
        .filter((col) => col.visible)
        .map((col): CSVLinkProps['headers'][number] => ({
          label: col.label,
          key: col.key,
        })),
    [columns]
  )

  const dataToDownload = useMemo(
    () =>
      filteredItems.map(
        (item): DownloadItem => ({
          name: item.name,
          nip: item.nip,
          satuanPendidikan: item.satuanPendidikan,
          jabatan: item.jabatan,
          praktikKinerja:
            PRAKTIK_KINERJA_RATING_LABEL[item.praktikKinerja] || '-',
          perilakuKerja: PERILAKU_KERJA_RATING_LABEL[item.perilakuKerja] || '-',
          predikatKinerja: PREDIKAT_LABELS[item.predikat] || '-',
          statusPengiriman: STATUS_PENGIRIMAN_LABEL[item.statusPengiriman],
        })
      ),
    [filteredItems]
  )

  return (
    <Button
      as={CSVLink}
      size="sm"
      className="text-nowrap"
      color="white"
      data={dataToDownload}
      headers={headers}
      filename={
        fileName ||
        generateCsvFileName('Data Penetapan Predikat Kinerja Pegawai')
      }
    >
      Unduh data
    </Button>
  )
}
